import type { RestaurantDetailResponse, RolloutDetail } from './menuChangeService';

/** Only this local destination can be resumed after login. Retain its complete query. */
export function getMenuChangeReturnPath(value: unknown): string | null {
  if (typeof value !== 'string' || /[\\\r\n]/.test(value)) return null;
  try {
    const url = new URL(value, 'https://menu-change.invalid');
    if (url.origin !== 'https://menu-change.invalid' || !/^\/menus\/change-dashboard\/[a-zA-Z0-9_-]+$/.test(url.pathname) || !value.startsWith('/menus/')) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return null; }
}

export interface MenuChangeLinkTarget { rollout: RolloutDetail; weekPos: number; taskId?: string }

/** Resolve only the requested original rollout/week/task; never substitute the current rollout. */
export function resolveMenuChangeLink(detail: RestaurantDetailResponse, restaurantId: string, search: string): MenuChangeLinkTarget | null {
  const params = new URLSearchParams(search);
  const rolloutId = params.get('rollout');
  const week = params.get('week');
  const taskId = params.get('task');
  if (params.getAll('rollout').length !== 1 || params.getAll('week').length !== 1 || params.getAll('task').length > 1 || !rolloutId || !week || !/^[1-9]\d*$/.test(week)) return null;
  const rollout = [detail.active, ...detail.history].find(item => item?.id === rolloutId && item.restaurantId === restaurantId);
  const selectedWeek = rollout?.weeks.find(item => item.pos === Number(week));
  if (!rollout || !selectedWeek || (params.has('task') && !selectedWeek.tasks.some(task => task.taskId === taskId))) return null;
  return { rollout, weekPos: selectedWeek.pos, ...(taskId ? { taskId } : {}) };
}
